// extracted by mini-css-extract-plugin
module.exports = {"component":"List_component__3X4hW"};